import { inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/abstract-classes/api.service/api.service';
import { ProfileWeight } from 'src/app/interfaces/profile-weight';
import { ProfileWeightsProviderService } from 'src/app/providers/profile-weights/profile-weights.provider.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileWeightsService extends ApiService<ProfileWeight, ProfileWeightsProviderService> {
  private profileWeightsProviderService = inject(ProfileWeightsProviderService);
  protected override get provider(): ProfileWeightsProviderService {
    return this.profileWeightsProviderService;
  }
}
